const HelpPage = () => (
    <div>
      This is rendering from dashboard page.
    </div>
  );
export default HelpPage;